<template>
  <div class="ChatFilters">
    <!-- Top Line: Filter Experts Title -->
    <div class="overlay"></div>
    <div class="filters-header">
      <p class="main-head">
        Filters <span class="filter-count">{{ totalSelectedFilters }}</span>
      </p>
      <div class="filter-summary">
        <!-- <button class="clear-btn" @click="clearAllFilters" >Clear all</button> -->
        <button class="clear-btn">Clear all</button>
      </div>
    </div>

    <!-- Filter Sections -->
    <div class="filter-sections">
      <div v-for="(filter, index) in filters" :key="filter.id">
        <!-- Filter Title -->
        <!-- <div class="filter-title" @click="toggleFilter(index)" > -->
        <div class="filter-title" @click="">
          <span>{{ filter.title }}</span>
          <el-icon :class="expandedFilter === index
            ? 'el-icon-arrow-up'
            : 'el-icon-arrow-down'
            " class="font-weight-700"></el-icon>
        </div>

        <!-- Filter Options -->
        <div v-if="expandedFilter === index" class="filter-options">
          <el-checkbox-group v-model="selectedFilters[filter.id]">
            <div v-for="option in filter.filter" :key="option" class="checkbox-option">
              <el-checkbox :label="option" disabled>{{ option }}</el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['filters'],
  data() {
    return {
      expandedFilter: 0,
      // filters: [
      //   {
      //     id: 1,
      //     title: "Skills",
      //     options: [
      //       "Fundamental Analysis",
      //       "Technical Analysis",
      //       "Short term Research",
      //       "Long Term Research",
      //       "Multibagger Specialist",
      //       "IPO"
      //     ],
      //   },
      //   {
      //     id: 2,
      //     title: "Asset class",
      //     options: [
      //       "Equity",
      //       "F&O",
      //       "Commodity",
      //       "Market Overview",
      //       "Penny stocks"
      //     ],
      //   },
      //   {
      //     id: 3,
      //     title: "Experience",
      //     options: [
      //       "< 3years",
      //       "3-7years",
      //       "> 7years",
      //     ],
      //   },
      //   {
      //     id: 4,
      //     title: "Availability",
      //     options: [
      //       "Online",
      //       "Offline",
      //       "Busy"
      //     ],
      //   },
      //   // Add more filters as needed
      // ],
      selectedFilters: {
        1: ["Fundamental Analysis"],
        2: [],
        3: [],
        4: [],
      },
    };
  },
  computed: {
    totalSelectedFilters() {
      // Compute the total number of selected filters across all sections
      return Object.values(this.selectedFilters).reduce(
        (acc, selected) => acc + selected.length,
        0
      );
    },
  },
  methods: {
    toggleFilter(index) {
      // Toggle the selected filter and close others
      this.expandedFilter = this.expandedFilter === index ? null : index;
    },
    clearAllFilters() {
      // Clear all selected filters
      Object.keys(this.selectedFilters).forEach((key) => {
        this.selectedFilters[key] = [];
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.ChatFilters {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 65px);
  background-color: #eceff4;
  border-right: 1px solid #ddd;
  padding: 20px;
  width: 230px;

  .filter-sections {
    overflow-y: auto;
    flex-grow: 1;
  }

  .filters-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;

    .main-head {
      margin: 0;
      font-size: 14px;
      color: #7c7c7c;
      font-weight: 500;

      .filter-count {
        border: 1px solid #ddd;
        padding: 1px 5px;
        border-radius: 4px;
        margin-left: 5px;
        background-color: #ddd;
      }
    }

    .filter-summary {
      display: flex;
      align-items: center;

      span {
        margin-right: 20px;
        font-weight: bold;
        color: #666;
      }

      .clear-btn {
        background-color: transparent;
        border: none;
        color: #2488ff;
        cursor: not-allowed;
        // cursor: pointer;
        font-weight: 500;
        font-size: 11px;
      }
    }
  }

  .filter-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: not-allowed;
    // cursor: pointer;
    margin-bottom: 0px;
    padding: 10px;
    border-radius: 4px;
    transition: background-color 0.3s;
    font-size: 12px;
    color: #000;
    font-weight: 600;

    &:hover {
      background-color: #e0e0e0;
    }

    .el-icon {
      font-size: 14px;
      margin-left: 10px;
    }
  }

  .filter-options {
    padding-left: 10px;
    margin-bottom: 15px;
  }

  .checkbox-option {
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 1284px) {
  .ChatFilters {
    height: calc(100vh - 153px);
  }
}
</style>
<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.ChatFilters {
  .el-checkbox__label {
    font-size: 11px;
    color: #000;
    cursor: not-allowed;
  }

  .el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #919295;
  }

  .el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #fbfbfb;
  }
}
</style>
